// Dados da página de vendas do Editor Premium Legendas
// Portado de Editor-Premium-lading/frontend/src/mock.js

export const productData = {
  id: 'editor_premium_legendas',
  name: 'Editor Premium Legendas',
  tagline:
    'Crie legendas profissionais no After Effects e no Premiere com muito mais velocidade, padrão visual e consistência.',
  description:
    'Um plugin para ganhar tempo e acelerar a tua edição — com mais de 35 textos animados prontos, presets, SRT e MOGRT para AE e Premiere Pro.',
  originalPrice: 459.0,
  currentPrice: 197.0,
  withoutPack: [
    'Criar a mesma legenda animada do zero em cada vídeo novo.',
    'Ficar caçando template em pasta, arquivo solto e tutorial no YouTube.',
    'Entregar vídeos com estilos diferentes porque cada um é um improviso.',
    'Demorar horas em algo que deveria levar 10 minutos.',
  ],
  withPack: [
    'Aplicar legenda animada em minutos, não em horas.',
    'Ter tudo organizado dentro do plugin, a um clique de distância.',
    'Entregar todos os vídeos com o mesmo padrão visual profissional.',
    'Editar mais vídeos no mesmo tempo, sem sacrificar a qualidade.',
  ],
  faqs: [
    {
      question: 'O Editor Premium funciona em quais programas?',
      answer:
        'O sistema foi pensado para Adobe After Effects e Adobe Premiere Pro, com fluxos complementares entre os dois ambientes.',
    },
    {
      question: 'Ele é só um pack de templates?',
      answer:
        'Não. A proposta é entregar um sistema de trabalho com painel, biblioteca, aplicação de templates, presets, assets e aceleração do fluxo de legendas.',
    },
    {
      question: 'Consigo importar arquivos SRT?',
      answer:
        'Sim. O fluxo contempla importação de SRT para acelerar a montagem das legendas no projeto.',
    },
    {
      question: 'Ele trabalha com MOGRT?',
      answer:
        'Sim. Existe fluxo com Motion Graphics Templates, especialmente no Premiere, para organização e aplicação mais rápida.',
    },
    {
      question: 'Por quanto tempo tenho acesso?',
      answer:
        'O acesso ao produto é anual conforme a oferta da página, com ativação por licença e suporte ao fluxo atual do sistema.',
    },
    {
      question: 'Isso serve para quem produz muito volume?',
      answer:
        'Sim. O ganho operacional aparece justamente para quem trabalha com frequência, precisa manter padrão e quer reduzir retrabalho.',
    },
  ],
  about: {
    name: 'Diorgy',
    imageUrl:
      'https://midia.packcinematografico.com/Gemini_Generated_Image_mn37zamn37zamn37.png',
    description:
      'Editor e motion designer com anos de experiência editando vídeos todo dia. O Editor Premium nasceu da própria frustração de perder horas criando legenda do zero — então criei um plugin que resolve isso de vez.',
  },
};

export const testimonials = [
  { image: 'https://midia.packcinematografico.com/Pagina%20de%20vendas/WhatsApp%20Image%202026-04-16%20at%2022.09.09%20(5).jpeg', alt: 'Depoimento 1' },
  { image: 'https://midia.packcinematografico.com/Pagina%20de%20vendas/WhatsApp%20Image%202026-04-16%20at%2022.09.09%20(4).jpeg', alt: 'Depoimento 2' },
  { image: 'https://midia.packcinematografico.com/Pagina%20de%20vendas/WhatsApp%20Image%202026-04-16%20at%2022.09.09%20(3).jpeg', alt: 'Depoimento 3' },
  { image: 'https://midia.packcinematografico.com/Pagina%20de%20vendas/WhatsApp%20Image%202026-04-16%20at%2022.09.09%20(2).jpeg', alt: 'Depoimento 4' },
  { image: 'https://midia.packcinematografico.com/Pagina%20de%20vendas/WhatsApp%20Image%202026-04-16%20at%2022.09.09%20(1).jpeg', alt: 'Depoimento 5' },
  { image: 'https://midia.packcinematografico.com/Pagina%20de%20vendas/WhatsApp%20Image%202026-03-26%20at%2013.08.14.jpeg', alt: 'Depoimento 6' },
  { image: 'https://midia.packcinematografico.com/Pagina%20de%20vendas/WhatsApp%20Image%202026-03-26%20at%2013.08.14%20(2).jpeg', alt: 'Depoimento 7' },
  { image: 'https://midia.packcinematografico.com/Pagina%20de%20vendas/WhatsApp%20Image%202026-03-26%20at%2013.08.14%20(1).jpeg', alt: 'Depoimento 8' },
];

export const resultVideos = [
  { id: 1, title: 'Há 20 anos', videoUrl: 'https://midia.packcinematografico.com/Wesley%20ff%20odnotn%2004.mp4', tag: 'Premiere Pro' },
  { id: 2, title: 'Área', videoUrl: 'https://midia.packcinematografico.com/Wesley%2026.mp4', tag: 'After Effects' },
  { id: 3, title: 'O mundo é', videoUrl: 'https://midia.packcinematografico.com/JS%2006.mp4', tag: 'Premiere Pro' },
  { id: 4, title: 'Eu falo', videoUrl: 'https://midia.packcinematografico.com/Jos%C3%A9%2005.mp4', tag: 'After Effects' },
];

export const bonuses = [
  {
    title: 'Legenda Pro 2.0',
    description:
      'Aprenda a criar textos imersivos e legendas dinâmicas que viralizam — tudo em um só treinamento. Passo a passo para Premiere Pro e After Effects.',
    image: 'https://midia.packcinematografico.com/Pagina%20de%20vendas/freepik_nhance-and-upscale-this-i_2818033185.png',
  },
  {
    title: 'Pack de Efeitos Sonoros',
    description:
      'Mais de 50 efeitos sonoros prontos para turbinar seus vídeos — whooshes, impacts, transições e muito mais. Aplique com 1 clique e eleve o nível do seu conteúdo.',
    image: 'https://midia.packcinematografico.com/Pagina%20de%20vendas/freepik_create-a-cinematic-cover-_2817955557.png',
  },
  {
    title: 'Pack de Overlays Visuais',
    description:
      'Coleção de overlays de luz, grãos, glitch e textura para adicionar profundidade e estilo cinematográfico a qualquer vídeo. Compatível com AE e Premiere Pro.',
    image: 'https://midia.packcinematografico.com/Pagina%20de%20vendas/freepik_create-a-cinematic-digita_2817961684.png',
  },
];
